(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[42],{

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "3Fn9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/InspirationalDescription.jsx


var __jsx = react_default.a.createElement;





var InspirationalDescription_InspirationalDescription = function InspirationalDescription(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description,
      centered = _ref.centered;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  if (!title && !subtitle && !description) {
    return null;
  }

  return __jsx("div", {
    className: classnames_default()('leading-1', {
      'text-center sm:pb-95 max-w-3/5 mx-auto': centered,
      'direction-rtl': isRTL
    })
  }, __jsx(Title["a" /* Title */], {
    theme: "none",
    className: "text-24 font-brand",
    hLevel: 3
  }, title), __jsx(Text["a" /* Text */], {
    theme: "none",
    className: "text-16 font-bold",
    text: subtitle
  }), __jsx(Text["a" /* Text */], {
    theme: "none",
    className: "text-16",
    text: description
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Img.jsx + 1 modules
var Img = __webpack_require__("X6TF");

// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/InspirationalPicture.jsx









var InspirationalPicture_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var InspirationalPicture_InspirationalPicture = function InspirationalPicture(_ref) {
  var className = _ref.className,
      descriptionStyle = _ref.descriptionStyle,
      _ref$disableRelativeP = _ref.disableRelativePadding,
      disableRelativePadding = _ref$disableRelativeP === void 0 ? false : _ref$disableRelativeP,
      imgClassName = _ref.imgClassName,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$isWide = _ref.isWide,
      isWide = _ref$isWide === void 0 ? false : _ref$isWide,
      link = _ref.link,
      radius = _ref.radius,
      ratioDisplay = _ref.ratioDisplay,
      ratioKey = _ref.ratioKey,
      subtitle = _ref.subtitle,
      title = _ref.title,
      url = _ref.url;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var padding = isWide ? 'calc(20 / 1440 * 100vw)' : 'min(calc(20rem / 16), calc(20 / 1180 * 100vw))';

  var descriptionText = InspirationalPicture_jsx("div", {
    className: classnames_default()('p-20 flex items-center text-white w-full', {
      'direction-rtl': isRTL
    }),
    "data-testid": "IG-item-".concat(index, "-link"),
    style: !disableRelativePadding ? {
      padding: padding
    } : {}
  }, InspirationalPicture_jsx("span", null, title, subtitle && InspirationalPicture_jsx(react["Fragment"], null, InspirationalPicture_jsx("br", null), InspirationalPicture_jsx("span", {
    className: "text-12 sm:text-10 lg:text-12 font-sans"
  }, subtitle))), link && InspirationalPicture_jsx("span", {
    className: "ms-auto ps-5 transition-transform duration-250 ease-in transform group-hover:ltr:translate-x-1/2 rtl:-translate-x-1/2"
  }, InspirationalPicture_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    hasRtl: true,
    width: "calc(10rem / 16)"
  })));

  var content = InspirationalPicture_jsx(react["Fragment"], null, InspirationalPicture_jsx(Img["a" /* Img */], {
    altMsg: title,
    className: classnames_default()(imgClassName, {
      'transition-transform duration-250 ease-in transform group-hover:scale-105 group-focus:scale-105': link
    }),
    ratioDisplay: ratioDisplay,
    ratioKey: ratioKey,
    url: url
  }), title && InspirationalPicture_jsx("div", {
    className: "absolute inset-0 text-16 sm:text-14 lg:text-16 font-brand leading-tight flex items-end",
    style: _objectSpread(_objectSpread({}, descriptionStyle), {}, {
      backgroundImage: 'linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, transparent 100px)'
    })
  }, descriptionText));

  return InspirationalPicture_jsx("div", {
    className: classnames_default()('group isolate overflow-hidden relative', {
      'rounded-12': !radius
    }, className),
    "data-testid": "IG-item-".concat(index),
    style: radius && {
      borderRadius: radius + 'px'
    }
  }, link ? InspirationalPicture_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "w-full",
    target: "_blank",
    trackingData: {
      actionGA: 'inspirationalGrid',
      categoryGA: 'landing',
      labelGA: title,
      thumbnailPosition: index + 1
    },
    url: link
  }, content) : content);
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridFancy.jsx










var InspirationalGridFancy_jsx = react_default.a.createElement;

function InspirationalGridFancy_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InspirationalGridFancy_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InspirationalGridFancy_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InspirationalGridFancy_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var InspirationalGridFancy_InspirationalGridFancy = function InspirationalGridFancy(_ref) {
  var pictures = _ref.pictures,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description;
  var containerStyles = getContainerStyles(FANCY_CONTAINER_RATIO);
  var leftPanelContentStyles = {
    width: 'calc(530 / 1440 * 100%)'
  };
  var centerPanelContentStyles = {
    width: 'calc(480 / 1440 * 100%)'
  };
  var rightPanelContentStyles = {
    width: 'calc(430 / 1440 * 100%)'
  };
  var relativePadding = {
    padding: 'calc(20 / 1440 * 100vw)'
  };
  var shouldDisplayInlineDescription = pictures.length < 5;
  var offsetIndex = shouldDisplayInlineDescription ? 1 : 0;

  var editorialZone = InspirationalGridFancy_jsx(InspirationalDescription_InspirationalDescription, {
    title: title,
    subtitle: subtitle,
    description: description,
    centered: !shouldDisplayInlineDescription
  });

  return InspirationalGridFancy_jsx(react["Fragment"], null, !shouldDisplayInlineDescription && editorialZone, InspirationalGridFancy_jsx("div", {
    className: "h-0 w-full relative",
    style: containerStyles
  }, InspirationalGridFancy_jsx("div", {
    className: "absolute inset-0 flex overflow-hidden"
  }, shouldDisplayInlineDescription ? InspirationalGridFancy_jsx("div", {
    style: leftPanelContentStyles,
    className: "h-full flex items-center justify-center"
  }, InspirationalGridFancy_jsx("div", {
    className: "max-w-3/5 w-full"
  }, editorialZone)) : InspirationalGridFancy_jsx("div", {
    style: leftPanelContentStyles,
    className: "h-full flex items-end justify-end"
  }, InspirationalGridFancy_jsx("div", {
    className: "bg-white rounded-12 shrink-0",
    style: InspirationalGridFancy_objectSpread({
      width: 'calc(820 / 530 * 100%)'
    }, relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    descriptionStyle: {
      paddingLeft: 'calc(280 / 820 * 100%)'
    },
    ratioDisplay: 780 / 1440 // $FlowFixMe

  }, pictures[0 - offsetIndex], {
    index: 0 - offsetIndex + 1
  })))), InspirationalGridFancy_jsx("div", {
    style: centerPanelContentStyles,
    className: "h-full flex flex-col items-end relative z-1"
  }, InspirationalGridFancy_jsx("div", {
    className: "shrink-0 mx-auto rounded-2 bg-white",
    style: InspirationalGridFancy_objectSpread({
      width: 'calc(320 / 480 * 100%)'
    }, relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    ratioDisplay: 280 / 1440 // $FlowFixMe

  }, pictures[1 - offsetIndex], {
    index: 1 - offsetIndex + 1
  }))), InspirationalGridFancy_jsx("div", {
    className: "bg-white rounded-12 shrink-0",
    style: InspirationalGridFancy_objectSpread({
      width: 'calc(420 / 480 * 100%)',
      marginRight: 'calc(-120 / 480 * 100%)'
    }, relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    ratioDisplay: 380 / 1440 // $FlowFixMe

  }, pictures[2 - offsetIndex], {
    index: 2 - offsetIndex + 1
  })))), InspirationalGridFancy_jsx("div", {
    style: rightPanelContentStyles,
    className: "h-full flex flex-col"
  }, InspirationalGridFancy_jsx("div", {
    className: "bg-white rounded-12 shrink-0",
    style: InspirationalGridFancy_objectSpread({
      width: 'calc(620 / 430 * 100%)'
    }, relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    descriptionStyle: {
      paddingLeft: 'calc((420% / 480 * 100) * (120 / 480) * (430 / 620) * (480 / 430))',
      // I'm gonna need you to trust me
      paddingRight: 'calc(180 / 620 * 100%)' // same

    },
    ratioDisplay: 580 / 1440 // $FlowFixMe

  }, pictures[3 - offsetIndex], {
    index: 3 - offsetIndex + 1
  }))), InspirationalGridFancy_jsx("div", {
    className: "bg-white rounded-12 shrink-0",
    style: InspirationalGridFancy_objectSpread({
      width: 'calc(320 / 430 * 100%)'
    }, relativePadding)
  }, InspirationalGridFancy_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    isWide: true,
    ratioDisplay: 280 / 1440 // $FlowFixMe

  }, pictures[4 - offsetIndex], {
    index: 4 - offsetIndex + 1
  })))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridFull.jsx

var InspirationalGridFull_jsx = react_default.a.createElement;



var InspirationalGridFull_InspirationalGridFull = function InspirationalGridFull(_ref) {
  var pictures = _ref.pictures;
  var containerStyles = getContainerStyles(FULL_CONTAINER_RATIO);
  return InspirationalGridFull_jsx("div", {
    className: "h-0 w-full relative",
    style: containerStyles
  }, InspirationalGridFull_jsx("div", {
    className: "absolute inset-0 flex overflow-hidden"
  }, InspirationalGridFull_jsx("div", {
    className: "inline-flex shrink-0 transform -translate-x-1/2 relative left-1/2"
  }, InspirationalGridFull_jsx("div", {
    style: {
      width: 'calc(580 / 1440 * 100vw)'
    }
  }, InspirationalGridFull_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "h-full",
    descriptionStyle: {
      paddingLeft: 'calc(190 / 1440 * 100vw)'
    },
    ratioDisplay: 1 / 2,
    ratioKey: HORIZONTAL_RATIO // $FlowFixMe

  }, pictures[0], {
    index: 1,
    radius: 10
  }))), InspirationalGridFull_jsx("div", {
    style: {
      width: 'calc(580 / 1440 * 100vw)',
      margin: '0 calc(40 / 1440 * 100vw)'
    }
  }, InspirationalGridFull_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "h-full",
    ratioDisplay: 1 / 2,
    ratioKey: HORIZONTAL_RATIO // $FlowFixMe

  }, pictures[1], {
    index: 2,
    radius: 10
  }))), InspirationalGridFull_jsx("div", {
    style: {
      width: 'calc(580 / 1440 * 100vw)'
    }
  }, InspirationalGridFull_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "h-full",
    descriptionStyle: {
      paddingRight: 'calc(190 / 1440 * 100vw)'
    },
    ratioDisplay: 1 / 2,
    ratioKey: HORIZONTAL_RATIO // $FlowFixMe

  }, pictures[2], {
    index: 3,
    radius: 10
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridVertical.jsx

var InspirationalGridVertical_jsx = react_default.a.createElement;



var InspirationalGridVertical_InspirationalGridVertical = function InspirationalGridVertical(_ref) {
  var pictures = _ref.pictures;
  var containerStyles = getContainerStyles(VERTICAL_CONTAINER_RATIO);

  var spacer = InspirationalGridVertical_jsx("div", {
    className: "h-full shrink-0",
    style: {
      width: 'calc(20 / 1180 * 100%)'
    }
  });

  return InspirationalGridVertical_jsx("div", {
    className: "h-0 w-full relative",
    style: containerStyles
  }, InspirationalGridVertical_jsx("div", {
    className: "absolute inset-0 flex justify-between"
  }, InspirationalGridVertical_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "w-full",
    ratioDisplay: 1 / 3,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[0], {
    index: 1
  })), spacer, InspirationalGridVertical_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "w-full",
    ratioDisplay: 1 / 3,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[1], {
    index: 2
  })), spacer, InspirationalGridVertical_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    className: "w-full",
    ratioDisplay: 1 / 3,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[2], {
    index: 3
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridHorizontal.jsx



var InspirationalGridHorizontal_jsx = react_default.a.createElement;




var InspirationalGridHorizontal_InspirationalGridHorizontal = function InspirationalGridHorizontal(_ref) {
  var pictures = _ref.pictures,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description;
  var containerStyles = getContainerStyles(HORIZONTAL_CONTAINER_RATIO);
  var margin = {
    margin: '0 calc(20 / 1180 * 100%)'
  };
  return InspirationalGridHorizontal_jsx(react["Fragment"], null, InspirationalGridHorizontal_jsx(InspirationalDescription_InspirationalDescription, {
    title: title,
    subtitle: subtitle,
    description: description,
    centered: true
  }), InspirationalGridHorizontal_jsx("div", {
    className: "h-0 w-full relative",
    style: containerStyles
  }, InspirationalGridHorizontal_jsx("div", {
    className: "absolute inset-0 flex"
  }, InspirationalGridHorizontal_jsx("div", {
    className: "flex items-center"
  }, InspirationalGridHorizontal_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: VERTICAL_RATIO,
    ratioDisplay: 1 / 4 // $FlowFixMe

  }, pictures[0], {
    index: 1
  }))), InspirationalGridHorizontal_jsx("div", {
    className: "flex shrink-0",
    style: margin
  }, InspirationalGridHorizontal_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: HORIZONTAL_RATIO,
    imgClassName: "h-full",
    ratioDisplay: 1 / 2 // $FlowFixMe

  }, pictures[1], {
    index: 2
  }))), InspirationalGridHorizontal_jsx("div", {
    className: "flex items-center"
  }, InspirationalGridHorizontal_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioKey: VERTICAL_RATIO,
    ratioDisplay: 1 / 4 // $FlowFixMe

  }, pictures[2], {
    index: 3
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/layouts/InspirationalGridMainStage.jsx










var InspirationalGridMainStage_jsx = react_default.a.createElement;

function InspirationalGridMainStage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InspirationalGridMainStage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InspirationalGridMainStage_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InspirationalGridMainStage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var InspirationalGridMainStage_InspirationalGridMainStage = function InspirationalGridMainStage(_ref) {
  var description = _ref.description,
      pictures = _ref.pictures,
      subtitle = _ref.subtitle,
      title = _ref.title;
  var containerStyles = getContainerStyles(MAINSTAGE_CONTAINER_RATIO);
  var leftPanelContentStyles = {
    width: 'calc(280 / 1180 * 100%)'
  };
  var centerPanelContentStyles = {
    width: 'calc(355 / 1180 * 100%)'
  };
  var rightPanelContentStyles = leftPanelContentStyles;
  var margin = {
    margin: '0 calc(20 / 1180 * 100%) 0 auto'
  };
  var shouldDisplayInlineDescription = pictures.length < 3;
  var offsetIndex = shouldDisplayInlineDescription ? 1 : 0;

  var editorialZone = InspirationalGridMainStage_jsx(InspirationalDescription_InspirationalDescription, {
    title: title,
    subtitle: subtitle,
    description: description,
    centered: !shouldDisplayInlineDescription
  });

  return InspirationalGridMainStage_jsx(react["Fragment"], null, !shouldDisplayInlineDescription && editorialZone, InspirationalGridMainStage_jsx("div", {
    className: "h-0 w-full relative",
    style: containerStyles
  }, InspirationalGridMainStage_jsx("div", {
    className: "absolute inset-0 flex"
  }, InspirationalGridMainStage_jsx("div", {
    style: leftPanelContentStyles,
    className: "flex items-center mr-auto"
  }, shouldDisplayInlineDescription ? editorialZone : InspirationalGridMainStage_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioDisplay: 280 / 1180,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[0 - offsetIndex], {
    index: 1
  }))), InspirationalGridMainStage_jsx("div", {
    style: InspirationalGridMainStage_objectSpread(InspirationalGridMainStage_objectSpread({}, centerPanelContentStyles), margin),
    className: "ml-auto flex"
  }, InspirationalGridMainStage_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioDisplay: 355 / 1180,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[1 - offsetIndex], {
    index: 2
  }))), InspirationalGridMainStage_jsx("div", {
    style: rightPanelContentStyles,
    className: "flex items-center"
  }, InspirationalGridMainStage_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({
    ratioDisplay: 280 / 1180,
    ratioKey: VERTICAL_RATIO // $FlowFixMe

  }, pictures[2 - offsetIndex], {
    index: 3
  }))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/inspirational-grid/InspirationalGrid.jsx




var InspirationalGrid_jsx = react_default.a.createElement;












var HORIZONTAL_RATIO = ratios_utils["c" /* default */].XL;
var VERTICAL_RATIO = ratios_utils["c" /* default */].R_65_BY_48;
var MAINSTAGE_CONTAINER_RATIO = 480 / 1180;
var HORIZONTAL_CONTAINER_RATIO = 380 / 1180;
var VERTICAL_CONTAINER_RATIO = MAINSTAGE_CONTAINER_RATIO;
var FULL_CONTAINER_RATIO = 365 / 1440;
var FANCY_CONTAINER_RATIO = 620 / 1440;
var getContainerStyles = function getContainerStyles(ratio) {
  return {
    paddingBottom: "calc(".concat(ratio, " * 100%)")
  };
};

var InspirationalGrid_getComponentFromLayout = function getComponentFromLayout(layout) {
  switch (layout) {
    case 'mainStage':
      return InspirationalGridMainStage_InspirationalGridMainStage;

    case 'horizontal':
      return InspirationalGridHorizontal_InspirationalGridHorizontal;

    case 'vertical':
      return InspirationalGridVertical_InspirationalGridVertical;

    case 'full':
      return InspirationalGridFull_InspirationalGridFull;

    case 'fancy':
      return InspirationalGridFancy_InspirationalGridFancy;

    default:
      return InspirationalGridMainStage_InspirationalGridMainStage;
  }
};

var InspirationalGrid_InspirationalGrid = function InspirationalGrid(_ref) {
  var layout = _ref.layout,
      pictures = _ref.pictures,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      _useResponsive$isBrow = _useResponsive.isBrowserGreaterThan,
      isBrowserGreaterThan = _useResponsive$isBrow === void 0 ? {
    XS: true
  } : _useResponsive$isBrow;

  var numberOfPictures = pictures.length;
  var actualLayout = layout;

  if (numberOfPictures === 2) {
    actualLayout = 'mainStage';
  } else if (numberOfPictures >= 4) {
    actualLayout = 'fancy';
  }

  var TagName = InspirationalGrid_getComponentFromLayout(actualLayout);
  var shouldShowDescription = numberOfPictures === 2 || numberOfPictures === 4 || actualLayout === 'horizontal';
  var editorialProps = shouldShowDescription || !isBrowserGreaterThan.XS ? {
    title: title,
    subtitle: subtitle,
    description: description
  } : {};
  return isBrowserGreaterThan.XS ? InspirationalGrid_jsx("div", {
    className: "direction-ltr"
  }, InspirationalGrid_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: actualLayout === 'full' || actualLayout === 'fancy'
  }, InspirationalGrid_jsx(TagName, Object(esm_extends["a" /* default */])({
    pictures: pictures
  }, editorialProps)))) : InspirationalGrid_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: true
  }, InspirationalGrid_jsx("div", {
    className: "px-20 pb-40"
  }, InspirationalGrid_jsx(InspirationalDescription_InspirationalDescription, editorialProps)), InspirationalGrid_jsx("div", {
    className: "flex scroll-x scrollbar-hidden snap-x snap-mandatory"
  }, pictures.map(function (picture, index) {
    return InspirationalGrid_jsx("div", {
      className: classnames_default()('shrink-0 ps-15 snap-start', {
        'me-15': index === pictures.length - 1
      }),
      key: index,
      style: {
        width: '80vw'
      }
    }, InspirationalGrid_jsx(InspirationalPicture_InspirationalPicture, Object(esm_extends["a" /* default */])({}, picture, {
      ratioKey: VERTICAL_RATIO,
      ratioDisplay: 0.8,
      disableRelativePadding: true
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/inspirational-grid-line/InspirationalGridLine.jsx


var InspirationalGridLine_jsx = react_default.a.createElement;


var InspirationalGridLine_InspirationalGridLine = function InspirationalGridLine(_ref) {
  var description = _ref.description,
      layout = _ref.layout,
      pictures = _ref.pictures,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return InspirationalGridLine_jsx("div", {
    className: "Line",
    id: "inspirationalGrid"
  }, InspirationalGridLine_jsx(InspirationalGrid_InspirationalGrid, {
    description: description,
    layout: layout,
    pictures: pictures,
    subtitle: subtitle,
    title: title
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/inspirational-grid/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (InspirationalGridLine_InspirationalGridLine);

/***/ }),

/***/ "6Jj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductIntroductionActions; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("0IQ5");
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NJJ8");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var ProductIntroductionActions = function ProductIntroductionActions(_ref) {
  var className = _ref.className,
      _ref$ratingImage = _ref.ratingImage,
      ratingImage = _ref$ratingImage === void 0 ? {} : _ref$ratingImage;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'flex flex-col items-center sm:items-stretch')
  }, ratingImage && ratingImage.src && __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_4__[/* TrackClick */ "a"], {
    as: _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"],
    className: "border-1 border-sand leading-0 p-5 rounded-12 text-center",
    trackingData: {
      actionGA: 'practicalInfos',
      categoryGA: 'resort',
      labelGA: 'tripAdvisorAnchor'
    },
    url: "#tripadvisor"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_3__[/* Image */ "a"], {
    altMsg: ratingImage.alt,
    dontChangeAnything: true,
    imageUrl: ratingImage.src,
    ratioDisplay: 3 / 20
  })));
};

/***/ }),

/***/ "EvYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Modal_Modal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.themes.js
var MAX_HEIGHT = '70vh';
var sizes = {
  auto: 'auto',
  small: '23.75rem',
  // 380px
  medium: '40rem',
  // 640px
  large: '50rem' // 800px

};
var themes = function themes(_ref) {
  var size = _ref.size;
  return {
    "default": {
      thRoot: 'animate-fadeIn animate-scaleIn animation-duration-500 flex isolate relative ',
      thRootStyles: {
        width: sizes[size],
        maxWidth: '100%',
        maxHeight: MAX_HEIGHT,
        minHeight: 100
      },
      thCloseButton: 'absolute bg-white border-1 cursor-pointer leading-0 top-0 mb-10 end-0 p-5 rounded-full z-2',
      thCloseButtonLabel: 'sr-only',
      thCloseButtonStyles: {
        top: 'auto',
        bottom: '100%',
        width: 40,
        height: 40
      },
      thBody: 'bg-white max-h-full relative z-1 overflow-hidden rounded-12 shadow w-full flex flex-col',
      thBodyStyles: {
        maxHeight: MAX_HEIGHT
      },
      // ⚠️ relative is only needed to prevent a weird bug of reflow on chrome
      thContent: 'isolate max-h-full overflow-auto relative w-full',
      thAddendum: 'max-h-full fixed bottom-0 inset-x-0 overflow-hidden rounded-4 md:rounded-2 shadow w-full',
      thAddendumStyles: {
        maxHeight: MAX_HEIGHT
      },
      thAddendumContent: 'max-h-full overflow-auto relative w-full'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.jsx

var __jsx = react_default.a.createElement;






var Modal_Modal = function Modal(_ref) {
  var addendum = _ref.addendum,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      backdropColor = _ref.backdropColor,
      backdropOpacity = _ref.backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
      header = _ref.header,
      id = _ref.id,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Modal' : _ref$dataTestId,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var modalButtonRef = Object(react["useRef"])();
  var closeBtnModal = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  Object(react["useEffect"])(function () {
    modalButtonRef.current && modalButtonRef.current.focus();
  }, []);
  var _themes$theme = themes({
    size: size
  })[theme],
      thAddendum = _themes$theme.thAddendum,
      thAddendumStyles = _themes$theme.thAddendumStyles,
      thAddendumContent = _themes$theme.thAddendumContent,
      thBody = _themes$theme.thBody,
      thBodyStyles = _themes$theme.thBodyStyles,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyles = _themes$theme.thCloseButtonStyles,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thContent = _themes$theme.thContent,
      thRoot = _themes$theme.thRoot,
      thRootStyles = _themes$theme.thRootStyles;
  return __jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: ariaLabelledby,
    bgColor: backdropColor,
    onClose: onClose,
    opacity: backdropOpacity,
    portalName: portalName
  }, __jsx("aside", {
    className: thRoot,
    id: id,
    style: thRootStyles,
    "data-testid": dataTestId
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    "data-testid": "Modal-close",
    onClick: onClose,
    ref: modalButtonRef,
    style: thCloseButtonStyles,
    type: "button"
  }, closeBtnModal && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnModal), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), __jsx("div", {
    className: thBody,
    style: thBodyStyles
  }, header, __jsx("div", {
    className: classnames_default()(className, thContent)
  }, children)), addendum && __jsx("div", {
    className: thAddendum,
    style: thAddendumStyles
  }, __jsx("div", {
    className: classnames_default()(className, thAddendumContent)
  }, addendum))));
};

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "hA0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductLogo_ProductLogo; });

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.theme.js

var themes = {
  "default": function _default(_ref) {
    var isExclusiveCollection = _ref.isExclusiveCollection;
    return {
      thRoot: 'text-center',
      thIcon: classnames_default()('mb-15', {
        'bg-lightSand rounded-full text-black p-15': !isExclusiveCollection
      }, {
        'border-5 border-ultramarine rounded-12 text-ultramarine p-10': isExclusiveCollection
      }),
      thIconWidth: 'calc(100rem / 16)',
      thIsNotSquare: false,
      thProductInfo: 'flex flex-col-reverse text-initial',
      thProductCountry: 'font-bold text-14 text-sienna truncate w-full',
      thProductName: 'font-bold leading-tight text-18'
    };
  },
  calendar: function calendar() {
    return {
      thRoot: 'font-brand leading-tight text-black text-center text-16',
      thIconWidth: '5rem',
      thIsNotSquare: true
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx
var __jsx = react_default.a.createElement;




var ProductLogo_ProductLogo = function ProductLogo(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      iconName = _ref.iconName,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isExclusiveCollection: isExclusiveCollection
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thIsNotSquare = _themes$theme.thIsNotSquare,
      thProductInfo = _themes$theme.thProductInfo,
      thProductName = _themes$theme.thProductName,
      thProductCountry = _themes$theme.thProductCountry;

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx(Icon["a" /* Icon */], {
    alt: productName,
    className: thIcon,
    isNotSquare: thIsNotSquare,
    name: iconName,
    width: thIconWidth
  }), __jsx("div", {
    className: thProductInfo
  }, productName && __jsx("p", {
    className: thProductName,
    "data-testid": "product-logo-name"
  }, productName), productCountry && __jsx("p", {
    className: thProductCountry,
    "data-testid": "product-logo-country"
  }, productCountry)));
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}



/***/ })

}]);